<script setup lang="ts">
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs.vue";
import { defineProps } from 'vue';

const props = defineProps({
  reportName: String,
});
</script>

<template>
  <div class="toolbar w-100">
    <Breadcrumbs :reportName="reportName"/>
    <div class="spacer" />
  </div>
</template>

<style lang="scss">
.toolbar {
  display: flex;
  align-items: center;
  margin: 8px 12px 4px;
}
</style>
